import { useCleanupLocalStorageOnPageLoad } from './useCleanupLocalStorageOnPageLoad'
import { useTrackRouteChange } from './useTrackRouteChange'

export function useAppHooks(): void {
  useTrackRouteChange()
  useCleanupLocalStorageOnPageLoad()
}
